import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { constants } from '../../constants';
import useMyMApi from "../../hooks/useMyMApi";
import useValidationRules from '../../hooks/useValidationRules';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMDataGrid } from '../../ui-elements/MyMDataGrid';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MyMTextBox } from '../../ui-elements/MyMTextBox';
import ValidatableDropDownList from '../../ui-parts/ValidatableDropDownList';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';
import { utility } from '../../utility';
import ValidatableCheckBoxDropDownList from '../../ui-parts/ValidatableCheckBoxDropDownList';

/**
 * UserInfo Page Component
 */
const UserInfo = ({ handleModalClose, userSeqNo, callbackUpdateUser }) => {
  const screenId = 'MyM204';
  const { controlSettings, messageList } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const validationRules = useValidationRules();
  const [isLoading, setIsLoading] = useState(false);
  const [userInfoDisp, setUserInfoDisp] = useState(null);
  const [selectedStatusValue, setSelectedStatusValue] = useState('');
  const { handleSubmit, control, formState, clearErrors, trigger } = useForm({
    mode: 'onSubmit',
  })
  // 2025.3.5 MyMine Version2.1対応 Add Start
  const [selectedRoleValue, setSelectedRoleValue] = useState('');
  const [selectContentInCharge, setSelectContentInCharge] = useState([]);
  // 2025.3.5 MyMine Version2.1対応 Add End

  /**
   * Submit時処理
   * @param {any} data
   * @param {any} e
   */
  const onSubmit = (data, e) => {
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    var message
    if (selectedStatusValue === constants.UserStatus.Deactive) { message = messageList.MyM_MSG_I_0077 }
    else if (selectedStatusValue === constants.UserStatus.Delete) { message = messageList.MyM_MSG_I_0078 }
    else { message = messageList.MyM_MSG_I_0001 }
    if (window.confirm(message)) {
      // 2024.5.8 MyMine Version1.5対応 Modify End
      const param = {
        UserId: userInfoDisp.UserInfoDispItem.UserId,
        CompanyId: (!data.company) ? null : data.company,
        RejectedReason: (Number(selectedStatusValue) === constants.UserStatus.Rejected) ? data.rejectedReason : '',
        UserSequenceNo: userSeqNo,
        RoleId: (!data.role) ? null : data.role,
        StatusId: selectedStatusValue,
        RhqContact: data.rhqContact,
        // 2025.3.5 MyMine Version2.1対応 Add Start
        ContentInCharge: (data.role === constants.UserRole.Uploaders) ? selectContentInCharge.join(',') : null,
        // 2025.3.5 MyMine Version2.1対応 Add End
      };

      /** APIリクエスト成功時コールバック処理 */
      const callbackSuccess = () => {
        // 2024.5.8 MyMine Version1.5対応 Modify Start
        var message
        if (selectedStatusValue === constants.UserStatus.Delete) { message = messageList.MyM_MSG_I_0009 }
        else { message = messageList.MyM_MSG_I_0002 }
        window.alert(message);
        // 2024.5.8 MyMine Version1.5対応 Modify Start
        handleModalClose();
        setIsLoading(false);
        callbackUpdateUser && callbackUpdateUser();
      }

      /** APIリクエスト失敗時コールバック処理 */
      const callbackFailed = () => {
        setIsLoading(false);
      }

      setIsLoading(true);
      apiRequest.requestJson('api/user-info/update', 'POST', callbackSuccess, callbackFailed, param);
    }
  };

  /**
   * Submitエラー時処理
   * @param {any} errors
   * @param {any} e
   */
  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  useEffect(() => {
    const callbackGetUserData = (result) => {
      setUserInfoDisp(result);
      setSelectedStatusValue(result.UserInfoDispItem.StatusId);
      // 2025.3.5 MyMine Version2.1対応 Add Start
      setSelectedRoleValue(result.UserInfoDispItem.RoleId);
      if (result.UserInfoDispItem.ContentInCharge != null) {
        setSelectContentInCharge(result.UserInfoDispItem.ContentInCharge.split(','));
      }
      // 2025.3.5 MyMine Version2.1対応 Add End
    }
    apiRequest.requestJson(`api/user-info/load?userSequenceNo=${userSeqNo}`, 'GET', callbackGetUserData);
  }, []);

  /**
   * Status変更
   * @param {any} e
   */
  const handleStatusChange = (e) => {
    setSelectedStatusValue(e.target.value);

    // Company・Roleの必須チェックが不要なステータスの場合、エラーをクリア
    if (needsRequireCompanyRole(e.target.value) === false) {
      // 2025.3.5 MyMine Version2.1対応 Modify Start
      clearErrors(['company', 'role', 'selectContentInCharge'])
      // 2025.3.5 MyMine Version2.1対応 Modify End
    }
  }

  // 2025.3.5 MyMine Version2.1対応 Add Start
  const handleRoleChange = (e) => {
    setSelectedRoleValue(e.target.value);
    setSelectContentInCharge([]);
  }

  const handleGetContentInCharge = (contentInChargeList, valueArrayString) => {
    const contentInChargeValue = [];
    const valueArray = valueArrayString.split(',').map(v => Number(v.trim()));    
   
    for (let i = 0; i < valueArray.length; i++) {
      for (let j = 0; j < contentInChargeList.length; j++) {
        if (valueArray[i] === contentInChargeList[j].Key) {
          contentInChargeValue.push(contentInChargeList[j].Key);
        }
      }
    }
    return contentInChargeValue;
  }
  // 2025.3.5 MyMine Version2.1対応 Add End

  /**
   * Status値からComapny・Roleの必須チェック要否を返す
   * @param {any} statusValue
   * @returns 要 : true / 否 : false
   */
  const needsRequireCompanyRole = (statusValue) => {
    // 2024.5.8 MyMine Version1.5対応 Modify Start
    // Status : Rejected,Deactive,Delete以外は必須
    const test = [constants.UserStatus.Rejected, constants.UserStatus.Deactive, constants.UserStatus.Delete];
    if (test.includes(statusValue)) { return false }
    else { return true }
    // 2024.5.8 MyMine Version1.5対応 Modify End
  }

  if (userInfoDisp === null)
    return <MyMProgress />

  const userInfoDispItem = userInfoDisp.UserInfoDispItem;

  // 2024.5.8 MyMine Version1.5対応 Add Start
  /** 一覧の列定義 */
  const columns = [
    {
      field: "STATUS_NAME",
      headerName: controlSettings.LabelList.lblStatusNameHeader,
      flex: 1,
      sortable: false,
    },
    {
      field: "CHANGE_DATE",
      headerName: controlSettings.LabelList.lblChangeDateHeader,
      flex: 1,
      sortable: false,
      type: 'datetime',
    },
  ];

  /*  * 一覧の内容定義 */
  const dataList = userInfoDisp.UserStatusHistoryList.map((row) => {
    return {
      id: row.ChangeDate,
      STATUS_NAME: row.Status,
      CHANGE_DATE: utility.formatDateTime(row.ChangeDate, 'yyyy/MM/dd HH:mm')
    }
  });

  // 2024.5.8 MyMine Version1.5対応 Add End

  return (
    <Box sx={{ height: "100%", overflowY: "auto" }}>
      <Grid container spacing={2} columns={12} alignItems="start" justify="center" sx={{ height: 500, padding: '8px 8px 0px 8px', '.MuiGrid-item': { paddingTop: '6px' } }}>
        {isLoading && <MyMProgress />}
        <Grid item xs={6}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblFirstNameTitle}
          </Box>
          <Box>
            <MyMTextBox inputValue={`${userInfoDispItem.FirstName ?? ''} ${userInfoDispItem.LastName ?? ''}`.trim()} disabled={true} width="100%"></MyMTextBox>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblUserIdTitle}
          </Box>
          <Box>
            <MyMTextBox inputValue={userInfoDispItem.UserId} disabled={true} width="100%"></MyMTextBox>
          </Box>
        </Grid>
        <Grid item xs={3}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblLatestLoggedInDateTitle}
          </Box>
          <Box>
            <MyMTextBox inputValue={utility.formatDateTime(userInfoDispItem.LastLoginDate, 'yyyy/MM/dd HH:mm')} disabled={true} width="100%"></MyMTextBox>
          </Box>
        </Grid>
        <Grid item xs={6} >
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblCompanyTitle}
          </Box>
          <Box>
            <ValidatableDropDownList
              control={control}
              name="company"
              defaultValue={userInfoDispItem.CompanyId}
              options={userInfoDisp.CompanyConditionList}
              needsBlank={true}
              formState={formState}
              rules={{ ...validationRules.conditionalRequired(needsRequireCompanyRole(selectedStatusValue)) }}
              maxWidth={true}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblCompanyUserInputedTitle}
          </Box>
          <Box>
            <MyMTextBox inputValue={userInfoDispItem.CompanyName} disabled={true} width="100%"></MyMTextBox>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblRoleTitle}
          </Box>
          <Box>
            {/*2025.3.5 MyMine Version2.1対応 Modify Start*/}
            <ValidatableDropDownList
              control={control}
              name="role"
              defaultValue={userInfoDispItem.RoleId}
              options={userInfoDisp.RoleConditionList}
              needsBlank={true}
              formState={formState}
              rules={{ ...validationRules.conditionalRequired(needsRequireCompanyRole(selectedStatusValue)) }}
              maxWidth={true}
              onChange={
                handleRoleChange
              }
            />
            {/*2025.3.5 MyMine Version2.1対応 Modify End*/}
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblStatusTitle}
          </Box>
          <Box>
            <ValidatableDropDownList
              control={control}
              name="status"
              defaultValue={selectedStatusValue}
              // 2024.5.8 MyMine Version1.5対応 Modify Start
              options={
                [...userInfoDisp.StatusConditionList,
                { Key: constants.UserStatus.Delete, Value: controlSettings.LabelList.ddlDeteleValue }]
              }
              // 2024.5.8 MyMine Version1.5対応 Modify End
              needsBlank={true}
              formState={formState}
              onChange={handleStatusChange}
              rules={{ ...validationRules.required() }}
              maxWidth={true}
            />

          </Box>
        </Grid>
        {/*2025.3.5 MyMine Version2.1対応 Add Start*/}
        {selectedRoleValue === constants.UserRole.Uploaders &&
          <>
            <Grid item xs={6}>
              <Box className='fw-bold'>
                {controlSettings.LabelList.lblContentInCharge}
              </Box>
            <Box>
              <ValidatableCheckBoxDropDownList
                maxWidth
                multiple
                control={control}
                formState={formState}
                needsBlank={false}
                onChange={async (value) => {
                  await setSelectContentInCharge(value);
                  await trigger('selectContentInCharge');
                }}
                name="selectContentInCharge"
                defaultValue={userInfoDispItem.ContentInCharge === null || selectedRoleValue !== constants.UserRole.Uploaders || selectContentInCharge.length === 0 ? [] : handleGetContentInCharge(userInfoDisp.ContentInChargeList, userInfoDispItem.ContentInCharge)}
                  placeholder={controlSettings.LabelList.lblContentInChargeTitle}
                  value={selectContentInCharge ?? []}
                options={userInfoDisp.ContentInChargeList}
                rules={{ ...validationRules.listRequired(selectContentInCharge, () => needsRequireCompanyRole(selectedStatusValue), false) }}
                  style={{ background: 'white' }}
              />
              </Box>
            </Grid>
            <Grid item xs={6}>
            </Grid>
          </>
        }
        {/*2025.3.5 MyMine Version2.1対応 Add End*/}

        <Grid item xs={6}>
          <Box className='fw-bold'>
            {controlSettings.LabelList.lblRHQcontactTitle}
          </Box>
          <Box>
            <ValidatableTextBox
              control={control}
              name="rhqContact"
              defaultValue={userInfoDispItem.RhqContact}
              formState={formState}
              maxLength={256}
              rules={{
                ...validationRules.maxLength(256),
                ...validationRules.mailAddress(),
              }}
            />
          </Box>
        </Grid>
        <Grid item xs={6} sx={{ display: (Number(selectedStatusValue) === constants.UserStatus.Rejected ? '' : 'none') }}>
          {Number(selectedStatusValue) === constants.UserStatus.Rejected && (
            <FormControl sx={{ width: "100%" }}>
              <Box className='fw-bold'>
                {controlSettings.LabelList.lblRejectedReasonTitle}
              </Box>
              <Box>
                <ValidatableTextBox
                  control={control}
                  name="rejectedReason"
                  defaultValue={userInfoDispItem.RejectedReason}
                  formState={formState}
                  maxLength={1024}
                  rules={{
                    ...validationRules.required(),
                    ...validationRules.maxLength(1024)
                  }}
                />
              </Box>
            </FormControl>)}
        </Grid>
        <Grid item xs={6} sx={{ marginTop: 4, marginLeft: '9px', paddingRight: '9px' }}>
          <Grid container spacing={1} sx={{ border: 1, paddingBottom: 1, backgroundColor: '#F5F5F5', visibility: (userInfoDispItem.StatusId === constants.UserStatus.Requesting ? '' : 'hidden') }}>
            <Grid item xs={3}>
              {controlSettings.LabelList.lblRequestedDateTitle}
            </Grid>
            <Grid item xs={1}>:</Grid>
            <Grid item xs={8}>
              {utility.formatDateTime(userInfoDispItem.RequestedDate)}
            </Grid>
            <Grid item xs={3}>
              {controlSettings.LabelList.lblRequestedRHQContactTitle}
            </Grid>
            <Grid item xs={1}>:</Grid>
            <Grid item xs={8} sx={{ overflow: "auto" }}>
              {userInfoDispItem.RhqContact}
            </Grid>
          </Grid>
        </Grid>
        {/* 2024.5.8 MyMine Version1.5対応 Add Start */}
        <Grid item xs={6} sx={{ marginLeft: '-9px' }}>
          <Box className='fw-bold' style={{ width: '40%', height: '30%' }}>
            {controlSettings.LabelList.lblStatusHistoryTitle}
          </Box>
          <Box sx={{ height: '200px' }}>
            <MyMDataGrid
              rowHeight={40}
              columnHeaderHeight={40}
              columns={columns}
              dataList={dataList}
              disableColumnResize={true}
              uniquyKey={(row) => row.id}
            />
          </Box>
        </Grid>
        {/* 2024.5.8 MyMine Version1.5対応 Add End */}
        <Grid item xs={12}>
          <Stack direction='row' justifyContent="flex-end" spacing={3} className='me-3' sx={{ paddingTop: 2 }} >
            <MyMButton onClick={handleSubmit(onSubmit, onError)}>{controlSettings.LabelList.btnUpdate}</MyMButton>
            <MyMButton onClick={handleModalClose}>{controlSettings.LabelList.btnCancel}</MyMButton>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
}
export default UserInfo;